import Box from 'components/atomic/atoms/box/box.styled'

export default Box
